/* eslint-disable import/no-anonymous-default-export */
import { ReactComponent as hamburger_menu } from '../../../assets/imgs/hamburger-menu.svg';
import { ReactComponent as logo_gold } from '../../../assets/imgs/mark-austin__logo--gold.svg';
import { ReactComponent as logo_white } from '../../../assets/imgs/mark-austin__logo--white.svg';
import { ReactComponent as logo_cobalt } from '../../../assets/imgs/mark-austin__logo--cobalt.svg';
import { ReactComponent as twitter } from '../../../assets/social/twitter.svg';
import { ReactComponent as instagram_gold } from '../../../assets/social/instagram--gold.svg';
import { ReactComponent as instagram_white } from '../../../assets/social/instagram--white.svg';
import { ReactComponent as mail_white } from '../../../assets/icons/mail--white.svg';
import { ReactComponent as mail_gold } from '../../../assets/icons/mail--gold.svg';
import { ReactComponent as markaustindev } from '../../../assets/imgs/markaustin-dev__logo.svg';

export default {
  // Components
  hamburger_menu,
  // Brand Icons
  logo_gold,
  logo_white,
  logo_cobalt,

  // Social
  twitter,
  instagram_white,
  instagram_gold,

  // Brand Logos
  markaustindev,

  // Icons
  mail_gold,
  mail_white
};
